import { render } from "./ZhifuPage.vue?vue&type=template&id=d5ed6c28&scoped=true"
import script from "./ZhifuPage.vue?vue&type=script&lang=js"
export * from "./ZhifuPage.vue?vue&type=script&lang=js"

import "./ZhifuPage.vue?vue&type=style&index=0&id=d5ed6c28&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5ed6c28"]])

export default __exports__